import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./LOSPluginItem.module.css";
import Button from "shared/Button";
import RemovePluginModal from "../RemovePluginModal";

/**
 * View component. Displays info about a plugin.
 */
export function LOSPluginItem({ pluginInfo }) {
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [noRefresh, setNoRefresh] = useState(false);
  const [notSync, setNotSync] = useState(false);

  const losPlugins = {
    id: "123",
    name: "First Name Last Name",
    pluggedInto: "1234567",
    date: "02/24/2020",
    time: "11:01:01",
  };

  function handleRemove(checked) {
    if (noRefresh === checked) {
      setNoRefresh(!noRefresh);
    }
    if (notSync === checked) {
      setNotSync(!notSync);
    }
    setRemoveModalOpen(false);
  }

  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{pluginInfo.id}</div>
      <div className={styles.gridItem}>{pluginInfo.pluggedInIbo}</div>
      <div className={styles.gridItem}>{pluginInfo.pluggedInto}</div>
      <div className={styles.gridItem}>{pluginInfo.pluginPin}</div>
      <div className={styles.gridItem}>
        {pluginInfo.replace ? "True" : "False"}
      </div>
      <div className={styles.gridItem}>{pluginInfo.status}</div>

      <Button
        className={styles.button}
        onClick={() => {
          setRemoveModalOpen(true);
        }}
        size="tiny"
        children="Remove"
      />

      <RemovePluginModal
        type={"REMOVE LOS PLUGIN"}
        isOpen={removeModalOpen}
        doNotSync={false}
        withoutRefresh={false}
        pluginInfo={losPlugins}
        onClose={() => setRemoveModalOpen(false)}
        onClick={() => alert("Remove clicked ")}
        // onClick={handleRemove}
      />
    </div>
  );
}

LOSPluginItem.propTypes = {
  /**
   * Object with the plugins info.
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    pluggedInIbo: PropTypes.string,
    pluggedInto: PropTypes.string,
    pluginPin: PropTypes.string,
    replace: PropTypes.bool,
    status: PropTypes.number,
  }),
};
